<div class="container shippn-homepage-container d-block d-sm-block d-xs-block d-md-block d-lg-none"
  *ngIf="memberDetails?.id !== '64ad4904fd26fa274c2f5b5d' && memberDetails?.id !==  '64db269bfd26fa0d0c51a17d'">
  <div class="row"
    *ngIf="memberDetails?.id !== '64ad4904fd26fa274c2f5b5d' && memberDetails?.id !==  '64db269bfd26fa0d0c51a17d'">

    <div class="col-12 dashboard-quadro-menu dashboard-one-menu-for-affiliate">

      <button [routerLink]="['/','b2b','shipment-create']" type="button">
        <p>
          Create Shipment
        </p>
      </button>
      <button [routerLink]="['/','b2b','shipments']" type="button" class="active">
        <p>
          Shipments
        </p>
      </button>

    </div>
  </div>
</div>
<!-- Dashboard Wrapper -->
<div class="container shippn-homepage-container shippn-homepage-container-dashboard">
  <div style="box-shadow: 0 3px 14px 0 rgba(0, 0, 0, 0.16); border-radius: 15px;margin-bottom: 50px;">
    <div class="row">
      <div class="col-lg-2 col-xl-2 dashboard-nav-padding-right d-none d-sm-none d-xs-none d-md-none d-lg-block">
        <div style="background-color: white;padding: 15px 0px;">
          <ul class="dashboard-nav">
            <li style="cursor: unset;margin-top: 55px;">
              <div style="text-align: center;width:100%">
                <div style="text-align: center;">
                  <img style="width: 75px;height: 75px;object-fit: cover;border-radius: 50%;border: 2px solid black;"
                    class="img-responsive img-circle" src="{{memberDetails?.profile_image_url}}"
                    alt="Shippn host profile picture, avatar, photograph">

                  <div>
                    <h4 *ngIf="memberDetails"
                      style="font-size: 16px;font-weight: 900;color: black;margin-bottom: 5px;margin-top: 10px;"
                      translate="no">
                      {{memberDetails?.name}}</h4>
                    <h4 *ngIf="memberDetails?.city_name || memberDetails?.country_name"
                      style="font-size: 13px;font-weight: 300;color: black;margin-bottom: 5px;">
                      {{memberDetails?.city_name}} / {{memberDetails?.country_name}}</h4>


                  </div>
                </div>
              </div>
            </li>

            <li style="margin-top: 10px;" [routerLink]="['/','b2b','shipment-create']">
              <div
                style="background-color:transparent;height: 85px;width: 7px;border-radius: 0px 40px 40px 0px;position: absolute;">
              </div>
              <div style="text-align: center;width:100%">
                <i class="fas fa-shipping-fast" style="color: #222; font-size: 24px;"></i>
                <h4 style="color: #222;font-size: 11px;margin-top: 10px;">Create Shipment</h4>
              </div>
            </li>

            <li>
              <div
                style="background-color: #fc7137;height: 85px;width: 7px;border-radius: 0px 40px 40px 0px;position: absolute;">
              </div>
              <div style="text-align: center;width:100%">
                <img _ngcontent-tve-c51="" src="../../../../../assets/img/dashboard/package_status_icon_orange.svg"
                  alt="Package Status Icon" style="width: 40px;">
                <h4 style="color:#ff6c36;font-size: 11px;margin-top: 10px;">Shipments</h4>
              </div>

            </li>
          </ul>
          <div style="width: 100%;display: flex; justify-content: center; margin-top: 15px; position: absolute; bottom: 15px;">
            <a [routerLink]="['/', 'b2b', 'dashboard']" style="font-size: 13px; text-align: center;">Switch to new version</a>
          </div>
        </div>
      </div>
      <div class="col-lg-10 col-xl-10 dashboard-card-padding-left">
        <div class="row d-none d-sm-none d-xs-none d-md-none d-lg-block">
          <div style="text-align: left;" class="col-md-12">
            <div class="dashboard-card-header-border-radius"
              style="height: 75px;display: flex;align-items: center;background: white;padding: 0px 0px;">
              <ul style="padding: 0;list-style: none;display: inline-flex;width: 100%;margin-bottom: 0;">
                <li [routerLink]="['/','b2b','shipments']" style="width: 100%;cursor: pointer;">
                  <div style="text-align: center;width:100%;height: 100%;" class="dashboard-bfm-tab-head">
                    <div style="display: inline-flex;align-items: center;height: 100%;">
                      <img style="width: 25px;margin-right: 10px;"
                        src="../../../../../assets/img/dashboard/package_status_icon_orange.svg"
                        alt="Shippn BFM icon active">
                      <h4 style="color: #fc7137;font-size: 14px;margin:0" class="dashboard-bigscreen-links">
                        Shipments
                      </h4>
                    </div>

                  </div>
                  <div style="background-color: #fc7137;height: 19px;width: 100%;margin-bottom: 10px;">
                  </div>
                </li>

              </ul>
            </div>

          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div style="background-color: white;border-radius: 0px 0px 15px 0px;">
              <div class="dashboard-card-content-border-radius"
                style="background: #fff;height: 630px;padding:0;border-radius: 0px 0px 15px 0px; border-left: 1px solid #ddd;">
                <div id="shippn-scroll" style="height:100%;max-height: 100%;overflow: auto; padding: 0 15px 15px;"
                  class="table-responsive">

                  <table mat-table matSort (matSortChange)="announceSortChange($event)" [dataSource]="dataSource"
                    class="b2b-shipment-list-table" *ngIf="shipmentsResponseData?.length > 0">
                    
                    <ng-container matColumnDef="CreatedDate">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef> Created Date </th>
                      <td mat-cell *matCellDef="let element" translate="no"> {{element?.created_date * 1000 | date:"dd.MM.yyyy HH:mm"}}
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="ShipmentNumber">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef> Shipment Number </th>
                      <td mat-cell *matCellDef="let element">
                        {{element?.shipment_number.replace('SHPNB-', '')}} </td>
                    </ng-container>
                    <ng-container matColumnDef="Carrier">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef> Carrier </th>
                      <td mat-cell *matCellDef="let element"> {{element?.shipment.company_name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Service">
                      <th mat-header-cell *matHeaderCellDef> Service </th>
                      <td mat-cell *matCellDef="let element"> {{element?.shipment.service_type_name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Destination">
                      <th mat-header-cell *matHeaderCellDef> Destination </th>
                      <td mat-cell *matCellDef="let element"> {{element?.destination_counyry_name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Recipient">
                      <th mat-header-cell *matHeaderCellDef> Recipient </th>
                      <td mat-cell *matCellDef="let element"> {{element?.recipient_full_name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Status">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef> Status </th>
                      <td mat-cell *matCellDef="let element"> {{element?.status_name}} </td>
                    </ng-container>

                    <ng-container matColumnDef="PickUp">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef> Pick Up </th>
                      <td mat-cell *matCellDef="let element">
                        <span *ngIf="(element?.pick_up_arranged_date && element?.pickup_created) && (element?.status >= 7 && element?.status < 98)" style="color:#5e89e7" (click)="openArrangePickupDetailDialog(element)" class="pickup-span">Scheduled</span>

                        <span *ngIf="(!element?.pick_up_arranged_date || !element?.pickup_created) && element?.status == 7" (click)="openArrangePickupDialog(element)" class="pickup-span">Unscheduled</span>

                        <span *ngIf="element?.status < 7 || element?.status == 98"> - </span>
                      </td>
                    </ng-container>

                    
                    <ng-container matColumnDef="TotalPaid">
                      <th mat-header-cell mat-sort-header *matHeaderCellDef> Total Paid </th>
                      <td mat-cell *matCellDef="let element">
                        <span *ngIf="element?.charge?.paid?.amount">${{element?.charge?.paid?.amount}}</span>

                        <span *ngIf="!element?.charge?.paid?.amount">N/A</span>

                        <a *ngIf="element.receipt_url" target="_blank" href="{{element.receipt_url}}"
                          style="display: block; color: var(--shippn-orange); font-size: 13px;">Receipt</a>

                      </td>
                    </ng-container>
                    <ng-container matColumnDef="Tracking">
                      <th mat-header-cell *matHeaderCellDef> Tracking </th>
                      <td mat-cell *matCellDef="let element">
                        <a href="{{element?.tracking_number}}" target="_blank"
                          style="color:#000000de; display: flex; gap:2px; align-items: center;"
                          *ngIf="element?.status >= 7 && element?.tracking_number?.length > 0 && element.status != 98">
                          <i class="fas fa-external-link-alt"></i> {{element?.awb_no}}
                        </a>
                        <span *ngIf="element?.status < 7 || element?.tracking_number?.length == 0">
                          N/A
                        </span>
                      </td>
                    </ng-container>
                    <ng-container matColumnDef="Actions">
                      <th mat-header-cell *matHeaderCellDef> Print </th>
                      <td mat-cell *matCellDef="let element">

                        <img style="width: 25px;" src="../../../../../assets/img/dashboard/print_icon.svg"
                          (click)="openPrintLabelAndInvoiceDialog(element)"
                          *ngIf=" element?.status >= 7 && element?.label_url" alt="Shippn BFM icon active">
                        <span *ngIf="element?.status < 7">
                          N/A
                        </span>

                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                  </table>

                  <div *ngIf="shipmentsResponseData?.length == 0 && memberDetails.is_b2b_user_active" class="no-shipment-crate-shipment-btn-holder">

                    <p>
                      Start your B2B shipping process by creating your first shipment.
                    </p>
                    <button class="btn shippn-from-to-area-go-btn" [routerLink]="['/','b2b','shipment-create']">
                      Create Shipment
                    </button>
                  </div>
                  <div *ngIf="shipmentsResponseData?.length == 0 && !memberDetails.is_b2b_user_active" class="no-shipment-crate-shipment-btn-holder">

                    <p>
                      Your B2B application is currently processing. Once it's approved, you can start creating shipments from here.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>